import { lazy } from 'solid-js'
import { messages } from '../../pages/browser-extension-landing-page/browser-extension-landing-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/browser-extension-landing-page/browser-extension-landing-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    path: '/browser-extension',
    titleMessage: messages.titleMessage,
}
